/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged, m11ReportSection01FoiChanged,
    m11ReportSection01ResourceChanged, selectM11ReportContainerFoi, selectM11ReportContainerResource,
    selectM11ReportSection01Foi, selectM11ReportSection01Resource, selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveProtocolSynopsisChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section11xState, setAlertModalState, setStartingSection11xState) => {

    let changesStates = {
        section11xState: section11xState
    };
    let response = await saveM11Changes(apiToken, 17, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection01Resource) {
            dispatch(m11ReportSection01ResourceChanged(response.m11ReportSection01Resource));
        }
        setStartingSection11xState(JSON.parse(JSON.stringify(section11xState)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step017ProtocolSynopsis = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection01Foi = useSelector(selectM11ReportSection01Foi);
    const m11ReportSection01Resource = useSelector(selectM11ReportSection01Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section11xState, setSection11xState] = useState({
        "numberOfArmsStatus": "empty", "numberOfArmsXhtml": "",
        "trialBlindSchemaStatus": "empty", "trialBlindSchemaXhtml": "",
        "blindedRolesStatus": "empty", "blindedRolesXhtml": "",
        "numberOfParticipantsStatus": "empty", "numberOfParticipantsXhtml": "",
        "durationStatus": "empty", "durationXhtml": "",
        "committeesStatus": "empty", "committeesXhtml": ""
    });
    const [startingSection11xState, setStartingSection11xState] = useState({
        "numberOfArmsStatus": "empty", "numberOfArmsXhtml": "",
        "trialBlindSchemaStatus": "empty", "trialBlindSchemaXhtml": "",
        "blindedRolesStatus": "empty", "blindedRolesXhtml": "",
        "numberOfParticipantsStatus": "empty", "numberOfParticipantsXhtml": "",
        "durationStatus": "empty", "durationXhtml": "",
        "committeesStatus": "empty", "committeesXhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section11xState, startingSection11xState)),
        async saveAllChanges() {
            await
                saveProtocolSynopsisChanges(dispatch, apiToken, m11ResearchStudyFoi,
                    section11xState, setAlertModalState, setStartingSection11xState);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            console.log("initial calculation useEffect")
            let startingData = {
                "numberOfArmsStatus": "empty", "numberOfArmsXhtml": "",
                "trialBlindSchemaStatus": "empty", "trialBlindSchemaXhtml": "",
                "blindedRolesStatus": "empty", "blindedRolesXhtml": "",
                "numberOfParticipantsStatus": "empty", "numberOfParticipantsXhtml": "",
                "durationStatus": "empty", "durationXhtml": "",
                "committeesStatus": "empty", "committeesXhtml": ""
            };
            let blindedRoles = [];
            let independentCommittees = [];
            let otherCommittees = "";
            let durationAdditional = "";
            let durationParticipation = "";
            let durationIntervention = "";
            let assignedOrEnrolled = "";
            let targetOrMaximum = "";
            let numberOfArms = "";
            let trialBlindSchema = "";
            let targetNumber = "";
            if (m11ResearchStudyResource.recruitment?.targetNumber) {
                targetNumber = String(m11ResearchStudyResource.recruitment.targetNumber);
            }
            if (m11ResearchStudyResource.classifier?.length > 0) {
                for (const classifier of m11ResearchStudyResource.classifier) {
                    if (classifier.coding?.[0]?.system === "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl") {
                        if (classifier.coding[0].code === "C15228" ||
                            classifier.coding[0].code === "C187674" ||
                            classifier.coding[0].code === "C49659" ||
                            classifier.coding[0].code === "C28233") {
                            trialBlindSchema = classifier.coding[0].display;
                        } else if (classifier.coding[0].code === "C142578") {
                            independentCommittees.push(classifier.coding[0].display + (classifier.text ? " - " + classifier.text : ""));
                        } else if (classifier.coding[0].code === "C215671") {
                            independentCommittees.push(classifier.coding[0].display + (classifier.text ? " - " + classifier.text : ""));
                        } else if (classifier.coding[0].code === "C78726") {
                            independentCommittees.push(classifier.coding[0].display + (classifier.text ? " - " + classifier.text : ""));
                        } else if (classifier.coding[0].code === "C41132" &&
                            classifier.coding[0].display === "None (for Independent Committees) (C41132)"
                        ) {
                            independentCommittees.push(classifier.coding[0].display + (classifier.text ? " - " + classifier.text : ""));
                        } else if (classifier.coding[0].code === "C17649" &&
                            classifier.coding[0].display === "Other Independent Committee (C17649)") {
                            independentCommittees.push(classifier.coding[0].display + (classifier.text ? " - " + classifier.text : ""));
                        }
                    } else if (classifier.coding?.[0]?.system === "ForUseWithM11ReportAuthoringTool") {
                        if (classifier.coding[0].display === "Number of Arms") {
                            numberOfArms = classifier.text;
                        } else if (classifier.coding[0].display === "Target or Maximum") {
                            targetOrMaximum = classifier.text;
                        } else if (classifier.coding[0].display === "Assigned or Enrolled") {
                            assignedOrEnrolled = classifier.text;
                        } else if (classifier.coding[0].display === "Duration of Intervention") {
                            durationIntervention = classifier.text;
                        } else if (classifier.coding[0].display === "Duration of Participation") {
                            durationParticipation = classifier.text;
                        } else if (classifier.coding[0].display === "Additional Duration Comment") {
                            durationAdditional = classifier.text;
                        } else if (classifier.coding[0].display === "Other Committees") {
                            otherCommittees = classifier.text;
                        }
                    }
                }
            }
            if (m11ResearchStudyResource.extension?.length) {
                for (const extension of m11ResearchStudyResource.extension) {
                    if (extension.url === "http://hl7.org/fhir/StructureDefinition/blinded-role" &&
                        extension.valueCodeableConcept) {
                        blindedRoles.push(extension.valueCodeableConcept.coding[0].display);
                    }
                }
            }
            if (numberOfArms) {
                startingData.numberOfArmsStatus = "generated";
                startingData.numberOfArmsXhtml = "<div xmlns=\"http://www.w3.org/1999/xhtml\">" +
                    numberOfArms + "</div>";
            }
            if (trialBlindSchema) {
                startingData.trialBlindSchemaStatus = "generated";
                startingData.trialBlindSchemaXhtml = "<div xmlns=\"http://www.w3.org/1999/xhtml\">" +
                    trialBlindSchema + "</div>";
            }
            if (blindedRoles.length > 0) {
                startingData.blindedRolesStatus = "generated";
                startingData.blindedRolesXhtml = "<div xmlns=\"http://www.w3.org/1999/xhtml\">The following roles indicated will not be made aware of the treatment group assignment during the trial: " +
                    blindedRoles.join(", ") + "</div>";
            }
            if (targetNumber || targetOrMaximum || assignedOrEnrolled) {
                startingData.numberOfParticipantsStatus = "generated";
                startingData.numberOfParticipantsXhtml = "<div xmlns=\"http://www.w3.org/1999/xhtml\">A " +
                    targetOrMaximum + " of " + targetNumber +
                    " participants will be " + assignedOrEnrolled + ".</div>";
            }
            if (durationIntervention || durationParticipation || durationAdditional) {
                startingData.durationStatus = "generated";
                startingData.durationXhtml = "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Total planned duration of trial intervention for each participant:</p><p>" +
                    durationIntervention +
                    "</p><p>Total planned duration of trial participation for each participant:</p><p>" +
                    durationParticipation +
                    "</p>";
                if (durationAdditional) {
                    startingData.durationXhtml += "<p>" + durationAdditional + "</p>";
                }
                startingData.durationXhtml += "</div>";
            }
            if (independentCommittees.length > 0 || otherCommittees) {
                startingData.committeesStatus = "generated";
                startingData.committeesXhtml = "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Independent Committees: " +
                    independentCommittees.join(", ") + "</p>";
                if (otherCommittees) {
                    startingData.committeesXhtml += "<p>Other Committees: " + otherCommittees + "</p>";
                }
                startingData.committeesXhtml += "</div>";
            }
            startingData.loaded = true;
            console.log(startingData.committeesStatus)
            console.log(startingData.committeesXhtml)
            setSection11xState(startingData);
            setStartingSection11xState(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[1]?.entry?.length) {
                let theFoi = getIdFromReference(m11ReportContainerResource.section[1].entry[0]);
                if (theFoi && !isNaN(theFoi) && theFoi !== m11ReportSection01Foi) {
                    dispatch(m11ReportSection01FoiChanged(theFoi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection01Foi && !isNaN(m11ReportSection01Foi)) {
            loadResource(m11ReportSection01Foi, "M11ReportSection01", apiToken, dispatch);
        }
    }, [m11ReportSection01Foi]);

    useEffect(() => {
        if (m11ReportSection01Resource && Object.keys(m11ReportSection01Resource).length > 0) {
            let startingData = {
                "numberOfArmsStatus": "empty", "numberOfArmsXhtml": "",
                "trialBlindSchemaStatus": "empty", "trialBlindSchemaXhtml": "",
                "blindedRolesStatus": "empty", "blindedRolesXhtml": "",
                "numberOfParticipantsStatus": "empty", "numberOfParticipantsXhtml": "",
                "durationStatus": "empty", "durationXhtml": "",
                "committeesStatus": "empty", "committeesXhtml": "", loaded: true
            };
            let dataLoaded = false;
            if (m11ReportSection01Resource.section?.[0]?.section?.[0]?.section?.length > 0) {
                if (m11ReportSection01Resource.section[0].section[0].section[2]?.text?.div &&
                    m11ReportSection01Resource.section[0].section[0].section[2].text.status !== "empty") {
                    startingData.numberOfArmsStatus = m11ReportSection01Resource.section[0].section[0].section[2].text.status;
                    startingData.numberOfArmsXhtml = m11ReportSection01Resource.section[0].section[0].section[2].text.div;
                    dataLoaded = true;
                } else {
                    startingData.numberOfArmsStatus = section11xState.numberOfArmsStatus;
                    startingData.numberOfArmsXhtml = section11xState.numberOfArmsXhtml;
                }
                if (m11ReportSection01Resource.section[0].section[0].section[3]?.text?.div &&
                    m11ReportSection01Resource.section[0].section[0].section[3].text.status !== "empty") {
                    startingData.trialBlindSchemaStatus = m11ReportSection01Resource.section[0].section[0].section[3].text.status;
                    startingData.trialBlindSchemaXhtml = m11ReportSection01Resource.section[0].section[0].section[3].text.div;
                    dataLoaded = true;
                } else {
                    startingData.trialBlindSchemaStatus = section11xState.trialBlindSchemaStatus;
                    startingData.trialBlindSchemaXhtml = section11xState.trialBlindSchemaXhtml;
                }
                if (m11ReportSection01Resource.section[0].section[0].section[4]?.text?.div &&
                    m11ReportSection01Resource.section[0].section[0].section[4].text.status !== "empty") {
                    startingData.blindedRolesStatus = m11ReportSection01Resource.section[0].section[0].section[4].text.status;
                    startingData.blindedRolesXhtml = m11ReportSection01Resource.section[0].section[0].section[4].text.div;
                    dataLoaded = true;
                } else {
                    startingData.blindedRolesStatus = section11xState.blindedRolesStatus;
                    startingData.blindedRolesXhtml = section11xState.blindedRolesXhtml;
                }
                if (m11ReportSection01Resource.section[0].section[0].section[5]?.text?.div &&
                    m11ReportSection01Resource.section[0].section[0].section[5].text.status !== "empty") {
                    startingData.numberOfParticipantsStatus = m11ReportSection01Resource.section[0].section[0].section[5].text.status;
                    startingData.numberOfParticipantsXhtml = m11ReportSection01Resource.section[0].section[0].section[5].text.div;
                    dataLoaded = true;
                } else {
                    startingData.numberOfParticipantsStatus = section11xState.numberOfParticipantsStatus;
                    startingData.numberOfParticipantsXhtml = section11xState.numberOfParticipantsXhtml;
                }
                if (m11ReportSection01Resource.section[0].section[0].section[6]?.text?.div &&
                    m11ReportSection01Resource.section[0].section[0].section[6].text.status !== "empty") {
                    startingData.durationStatus = m11ReportSection01Resource.section[0].section[0].section[6].text.status;
                    startingData.durationXhtml = m11ReportSection01Resource.section[0].section[0].section[6].text.div;
                    dataLoaded = true;
                } else {
                    startingData.durationStatus = section11xState.durationStatus;
                    startingData.durationXhtml = section11xState.durationXhtml;
                }
                if (m11ReportSection01Resource.section[0].section[0].section[7]?.text?.div &&
                    m11ReportSection01Resource.section[0].section[0].section[7].text.status !== "empty") {
                    startingData.committeesStatus = m11ReportSection01Resource.section[0].section[0].section[7].text.status;
                    startingData.committeesXhtml = m11ReportSection01Resource.section[0].section[0].section[7].text.div;
                    dataLoaded = true;
                } else {
                    startingData.committeesStatus = section11xState.committeesStatus;
                    startingData.committeesXhtml = section11xState.committeesXhtml;
                }
                console.log(startingData.committeesStatus)
                console.log(startingData.committeesXhtml)
                setSection11xState(startingData);
                setStartingSection11xState(startingData);
                console.log(dataLoaded)
                if (!dataLoaded) {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        } else {
            setInitialCalculationNeeded(true);
        }
    }, [m11ReportSection01Resource]);

    return <div>
        <h3>Complete Protocol Synopsis</h3>
        {!(m11ReportSection01Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        <p>If data is missing or you want to store changes as structured data, Go To Step 8 (Enter Overall Design Details part 2).</p>
        {section11xState.loaded && <>
            <h4 style={{ marginBottom: "0px" }}>Revise the Number of Arms summary as needed.</h4>
            {section11xState.numberOfArmsXhtml && <>
                <TextDivEntry elementName="numberOfArmsXhtml"
                    startingValue={section11xState.numberOfArmsXhtml}
                    setResourceState={setSection11xState} />
            </>}
            <h4 style={{ marginBottom: "0px" }}>Revise the Trial Blind Schema summary as needed.</h4>
            {section11xState.trialBlindSchemaXhtml && <>
                <TextDivEntry elementName="trialBlindSchemaXhtml"
                    startingValue={section11xState.trialBlindSchemaXhtml}
                    setResourceState={setSection11xState} />
            </>}
            <h4 style={{ marginBottom: "0px" }}>Revise the Blinded Roles summary as needed.</h4>
            {section11xState.blindedRolesXhtml &&
                <>
                    <TextDivEntry elementName="blindedRolesXhtml"
                        startingValue={section11xState.blindedRolesXhtml}
                        setResourceState={setSection11xState} />
                </>}
            <h4 style={{ marginBottom: "0px" }}>Revise the Number of Participants summary as needed.</h4>
            {section11xState.numberOfParticipantsXhtml &&
                <>
                    <TextDivEntry elementName="numberOfParticipantsXhtml"
                        startingValue={section11xState.numberOfParticipantsXhtml}
                        setResourceState={setSection11xState} />
                </>}
            <h4 style={{ marginBottom: "0px" }}>Revise the Duration summary as needed.</h4>
            {section11xState.durationXhtml &&
                <>
                    <TextDivEntry elementName="durationXhtml"
                        startingValue={section11xState.durationXhtml}
                        setResourceState={setSection11xState} />
                </>}
            <h4 style={{ marginBottom: "0px" }}>Revise the Committees summary as needed.</h4>
            {section11xState.committeesXhtml &&
                <>
                    <TextDivEntry elementName="committeesXhtml"
                        startingValue={section11xState.committeesXhtml}
                        setResourceState={setSection11xState} />
                </>
            }
        </>}
    </div >
});

const M11Step017ProtocolSynopsisHelperText = <div>
    <h3>Complete Protocol Synopsis</h3>
    <div style={{ textAlign: "left" }}>
        <p>Review the auto-generated summary from previously submitted data. This will be the content for Section 1.1 Protocol Synopsis with sections for Number of Arms, Trial Blind Schema, Blinded Roles, Number of Participants, Duration, and Committees.</p>
        <p>Revise content as desired.</p>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step017ProtocolSynopsisValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 17, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
        <h4>Step 17 (Complete Protocol Synopsis) {validationCheckState.step17numberOfChecks} issues checked. {validationCheckState.step17numberPassed} passed. {validationCheckState.step17numberFailed} failed.</h4>
        <p>Section 1.1 heading is 'Protocol Synopsis': {validationCheckState.resultCheckSection11Heading}</p>
        <p>Section 1.1 Protocol Synopsis does not have text: {validationCheckState.resultCheckSection11Text}</p>
        <p>Section 1.1.2 content includes 'Number of Arms:': {validationCheckState.resultCheckSection112NumberOfArms}</p>
        <p>Section 1.1.2 Number of Arms has content: {validationCheckState.resultCheckSection112NumberOfArmsContent}</p>
        <p>Section 1.1.2 content includes 'Trial Blind Schema:': {validationCheckState.resultCheckSection112TrialBlindSchema}</p>
        <p>Section 1.1.2 Trial Blind Schema has content: {validationCheckState.resultCheckSection112TrialBlindSchemaContent}</p>
        <p>Section 1.1.2 content includes 'Blinded roles: The following roles indicated will not be made aware of the treatment group assignment during the trial:': {validationCheckState.resultCheckSection112BlindedRoles}</p>
        <p>Section 1.1.2 Blinded Roles has content: {validationCheckState.resultCheckSection112BlindedRolesContent}</p>
        <p>Section 1.1.2 content includes 'Number of Participants:': {validationCheckState.resultCheckSection112NumberOfParticipants}</p>
        <p>Section 1.1.2 Number of Participants has content which includes 'participants will be': {validationCheckState.resultCheckSection112NumberOfParticipantsContent}</p>
        <p>Section 1.1.2 content includes 'Duration:': {validationCheckState.resultCheckSection112Duration}</p>
        <p>Section 1.1.2 Duration content includes 'Total planned duration of trial intervention for each participant:': {validationCheckState.resultCheckSection112DurationContentIntervention}</p>
        <p>Section 1.1.2 Duration content includes 'Total planned duration of trial participation for each participant:': {validationCheckState.resultCheckSection112DurationContentParticipation}</p>
        <p>Section 1.1.2 content includes 'Committees:': {validationCheckState.resultCheckSection112Committees}</p>
        <p>Section 1.1.2 Committees content includes 'Independent Committees:': {validationCheckState.resultCheckSection112CommitteesContent}</p>
    </div>}  </div>
}

export default M11Step017ProtocolSynopsis;
export { M11Step017ProtocolSynopsisHelperText, M11Step017ProtocolSynopsisValidationCheck };